import styled from 'styled-components';
import { lighten } from 'polished';

export const TextButton = styled.button`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-family: inherit;
  font-style: normal;
  font-size: 16px;
  font-weight: normal;
  border: none;
  outline: none;
  line-height: 1;
  max-width: 100%;
  width: auto;
  text-align: center;
  vertical-align: middle;
  text-decoration: none !important;
  white-space: nowrap;
  background: transparent;
  color: '#2A2A2A';
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1) all;
  padding: 0px;

  &:hover {
    text-decoration: underline !important;
    color: ${lighten(0.25, '#2A2A2A')};
  }

  &:active {
    color: '#2A2A2A';
  }

  &[disabled] {
    opacity: 0.4;
  }
`;
